import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setUser } from '@/redux/actions/userActions';
import AppRoutes from '@/router/appRoutes';
import { Header } from '@/components/general/Header';
import LoginModal from '@/components/pages/Home/modals/LoginModal';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '@/App.css';
import '@/style/main.scss';

function App() {
  const user = useSelector(state => state.user);
  const dispatch = useDispatch();

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showSpinner, setShowSpinner] = useState(true);

  useEffect(() => {
    const localUser = JSON.parse(localStorage.getItem('user'));

    if (user) {
      setIsLoggedIn(true);
      setShowSpinner(false);
    } else if (localUser) {
      dispatch(setUser(localUser));
      setIsLoggedIn(true);
      setShowSpinner(false);
    } else {
      setIsLoggedIn(false);
      setShowSpinner(false);
    }
  }, [user]);

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
  };

  if (showSpinner) {
    return (
      <div
        style={{
          position: 'fixed',
          inset: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          background: '#fff',
          zIndex: 10000,
        }}
      >
        <div className="spinner" />
      </div>
    );
  } else {
    if (isLoggedIn) {
      return (
        <div>
          <Header />
          <AppRoutes />
        </div>
      );
    } else {
      return <LoginModal open={true} onLoginSuccess={handleLoginSuccess} />;
    }
  }
}

export default App;
